import * as _ from "lodash"
import { PASearch } from "../PA.Core/PASearch";


const vUI_SimPolicy_Term_Values_schema = PASearch.createSimpleSchema(['RESERVED_TERM_ID','TERM_NAME','EFFECTIVE_START_DT','EFFECTIVE_END_DT'],
    ['WB_ENTITY_ID_CUSTOMER','WB_ENTITY_ID_PRODUCT','WB_ENTITY_ID_PERIOD','VALUE_NORMALIZED','WB_CUST_ID','WB_PRDGRP_ID','WB_PROD_ID','WB_PERIOD_ID', 'DAYS_OVERLAP'])

export interface vUI_SimPolicy_Term_Values_Row {
    WB_SALESORG_ID: number,
    RESERVED_TERM_ID: string
    TERM_NAME: string
    WB_ENTITY_ID_CUSTOMER: number
    WB_ENTITY_ID_PRODUCT: number
    WB_ENTITY_ID_PERIOD: number
    VALUE_NORMALIZED: number
    WB_CUST_ID: number
    WB_PRDGRP_ID: number
    WB_PROD_ID: number
    EFFECTIVE_START_DT: string
    EFFECTIVE_END_DT: string
    WB_PERIOD_ID: number
    DAYS_OVERLAP: number
}

export interface ISimulationPolicyTerms {
    GrossListPrice: number,
    CustomerListPrice: number,
    NetListPrice: number,
    COGs: number,
    VCM: number
}

export interface ISimulationPolicyTermsDictionary {
    [wbCustId: number]: {
        [wbPrdId: number]: {
            [wbPeriodId: number]: ISimulationPolicyTerms
        }
    }
}

export class SimulationPolicyUtils {

    static async PolicyTermValues_getCPG(wbSalesOrgId: number,
                                         wbEntityIdCustomer: number,
                                         wbEntityIdProduct: number,
                                         wbEntityIdPeriod: number,
                                         wbCustIds: number[],
                                         wbPrdGrpIds: number[],
                                         wbPeriodIds: number[]): Promise<ISimulationPolicyTermsDictionary>
    {
        let cnd: any = {
            WB_SALESORG_ID: wbSalesOrgId,
            WB_CUST_ID: wbCustIds,
            WB_PRDGRP_ID: wbPrdGrpIds,
            WB_PERIOD_ID: wbPeriodIds,
            WB_ENTITY_ID_CUSTOMER: wbEntityIdCustomer,
            WB_ENTITY_ID_PRODUCT: wbEntityIdProduct,
            WB_ENTITY_ID_PERIOD: wbEntityIdPeriod,
        }

        let rows = <vUI_SimPolicy_Term_Values_Row[]> await PASearch.find('vUI_SimPolicy_Term_Values', {where: {cnd}}, vUI_SimPolicy_Term_Values_schema, [], 0, [])

        let rv = SimulationPolicyUtils.convertToDictionary(rows)

        return rv
    }

    private static convertToDictionary(rows: vUI_SimPolicy_Term_Values_Row[]): ISimulationPolicyTermsDictionary {
        let rv: ISimulationPolicyTermsDictionary = {}
        for(let row of rows){
            let wbCustId = +row.WB_CUST_ID
            let wbPrdGrpId = +row.WB_PRDGRP_ID
            let wbPeriodId = +row.WB_PERIOD_ID

            if(!(wbCustId in rv))
                rv[wbCustId] = {}

            let dct2 = rv[wbCustId]
            if(!(wbPrdGrpId in dct2))
                dct2[wbPrdGrpId] = {}
            let dct3 = dct2[wbPrdGrpId]
            if(!(wbPeriodId in dct3)){
                dct3[wbPeriodId] = {
                    GrossListPrice: 0,CustomerListPrice: 0, NetListPrice: 0, COGs: 0, VCM: 0
                }
            }

            let prc = dct3[wbPeriodId]

            switch(row.RESERVED_TERM_ID){
                case "GrossListPrice":
                    prc.GrossListPrice = +row.VALUE_NORMALIZED
                    break
                case "CustomerListPrice":
                    prc.CustomerListPrice = +row.VALUE_NORMALIZED
                    break
                case "NetListPrice":
                    prc.NetListPrice = +row.VALUE_NORMALIZED
                    break
                case "COGs":
                    prc.COGs = +row.VALUE_NORMALIZED
                    break
                case "VCM":
                    prc.VCM = +row.VALUE_NORMALIZED
                    break
            }

        } // Next Row

        return rv
    }

    static PolicyTermValues_get(dct: ISimulationPolicyTermsDictionary, wbCustId: number, wbPrdId: number, wbPeriodId: number): ISimulationPolicyTerms {
        if(_.isEmpty(dct))
            return undefined
        if(!(wbCustId in dct))
            return undefined
        let dct2 = dct[wbCustId]
        if(!(wbPrdId in dct2))
            return undefined
        let dct3 = dct2[wbPrdId]
        if(!(wbPeriodId in dct3))
            return undefined

        return dct3[wbPeriodId]
    }

}